import { defineMessages } from 'react-intl';

export const presaleWarningScope = 'app.components.presaleWarning';

export const presaleWarningMessages = {
  presaleWarningTitle: {
    id: `${presaleWarningScope}.presaleWarningTitle`,
    defaultMessage: 'Prévente',
    en: 'Presale',
    it: 'Prevendita',
    es: 'Preventa',
    de: 'Vorverkauf',
    nl: 'Voorverkoop',
  },
  presaleWarningBody: {
    id: `${presaleWarningScope}.presaleWarningBody`,
    defaultMessage:
      'Vos billets seront disponibles ici dès l’ouverture des ventes',
    en: 'Your tickets will be available here as soon as sales open',
    it: 'I tuoi biglietti saranno disponibili qui non appena apriranno le vendite',
    es: 'Tus billetes estarán disponibles aquí en cuanto se abran las ventas',
    de: 'Deine Tickets sind hier verfügbar, sobald der Verkauf beginnt',
    nl: 'Je tickets zijn hier beschikbaar zodra de verkoop start',
  },
};

export default defineMessages(presaleWarningMessages);
